import { render, staticRenderFns } from "./SettingsBotsListChannel.vue?vue&type=template&id=6caf5b70&"
import script from "./SettingsBotsListChannel.vue?vue&type=script&lang=js&"
export * from "./SettingsBotsListChannel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports